import { ChartOfAccountId } from '@modules-deprecated/app/organization/enums/chartOfAccountId'

const EXCLUDED_COA: ChartOfAccountId[] = [ChartOfAccountId.BillyWorld, ChartOfAccountId.Manual]

export const isBookkeepingHeroAllowed = (chartOfAccountId: ChartOfAccountId): boolean =>
  !EXCLUDED_COA.includes(chartOfAccountId)
